import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Link } from "gatsby"

const About = () => {
  return (
    <>
      <Layout>
        <SEO 
          title="About - Search All Facebook Marketplace Worldwide" 
          description="Learn how to search all Facebook Marketplace listings worldwide. Our platform helps you find items for sale beyond the standard 100-mile radius."
        />
        <div className="about-section">
          <div className="about-content">
            <h1>About SearchWorld Marketplace</h1>
            <div className="about-main">
              <p className="about-intro">SearchWorld Marketplace is your premier tool for searching all Facebook Marketplace listings worldwide. Our platform was created to help users find items for sale beyond Facebook's standard 100-mile radius limitation.</p>
              
              <h2>Our Story</h2>
              <p>SearchWorld Marketplace was originally built for <a href="https://njtautomation.com/" target="_blank" rel="noopener" title="NJT Automation - Industrial Electronics Supply and Repair">NJT Automation</a>, an industrial electronics supplier in Milwaukee, Wisconsin. During the global chip shortage, sourcing hard-to-find automation components became extremely difficult through traditional channels. To find obsolete parts, suppliers often have to navigate the surplus market. You can <a href="https://njtautomation.com/guides/find-obsolete-allen-bradley-parts/" target="_blank" rel="noopener" title="Find Obsolete Allen-Bradley Parts - Gray Market Guide">learn about the automation gray market</a> and how it works.</p>
              <p>Components like <a href="https://njtautomation.com/2711P-T10C4D8/" target="_blank" rel="noopener" title="Allen-Bradley 2711P-T10C4D8 PanelView Plus">PanelView Plus terminals</a>, <a href="https://njtautomation.com/1756-L85E/" target="_blank" rel="noopener" title="Allen-Bradley 1756-L85E ControlLogix Processor">ControlLogix processors</a>, and <a href="https://njtautomation.com/2097-V34PR6/" target="_blank" rel="noopener" title="Allen-Bradley Kinetix 300 Servo Drive">Kinetix servo drives</a> had lead times stretching into months or even years. NJT needed a way to find surplus units that individuals and businesses were selling locally across the country.</p>
              <p>We developed this tool to search Facebook Marketplace nationwide, finding everything from a <a href="https://njtautomation.com/2711P-T10C22D9P/" target="_blank" rel="noopener" title="Allen-Bradley 2711P-T10C22D9P PanelView Plus 7">2711P-T10C22D9P</a> in Texas to <a href="https://njtautomation.com/2097-V34PR5-LM/" target="_blank" rel="noopener" title="Allen-Bradley 2097-V34PR5-LM Kinetix 300">2097-V34PR5-LM</a> and <a href="https://njtautomation.com/2097-v34pr3-lm/" target="_blank" rel="noopener" title="Allen-Bradley 2097-V34PR3-LM Kinetix 300">2097-V34PR3-LM</a> servo drives in Ohio. It proved so useful that we decided to make it available to everyone looking to search beyond Facebook's standard 100-mile radius.</p>

              <h2>Our Mission</h2>
              <p>We're dedicated to making Facebook Marketplace more accessible and useful for everyone. By allowing users to search all listings worldwide, we're helping people find exactly what they're looking for, no matter where it's located.</p>

              <h2>Why Use Us?</h2>
              <ul>
                <li>Search listings from any country or region</li>
                <li>Find rare and unique items worldwide</li>
                <li>Access better deals and more options</li>
                <li>Connect with sellers globally</li>
                <li>No fees or commissions</li>
              </ul>

              <h2>How It Works</h2>
              <p>Our platform makes it simple to search all Facebook Marketplace listings. Just enter your search term, and we'll show you results from around the world. You can browse through items from different countries and regions, giving you access to a much larger selection of items for sale.</p>

              <h2>Our Latest Project</h2>
              <p>Building on our experience in industrial electronics, we developed <a href="https://repairmode.com" target="_blank" rel="noopener" title="RepairMode - Electronics Repair Marketplace">RepairMode</a>, a software platform that connects businesses with independent repair technicians specializing in industrial equipment. The platform enables users to submit repair requests for HMIs, PLCs, servo drives, and other automation components, then receive and compare quotes from qualified technicians. <a href="https://njtautomation.com/guides/why-build-repairmode/" target="_blank" rel="noopener" title="Why We Built RepairMode">Learn more about why we built RepairMode.</a></p>
              <p><strong>Disclaimer:</strong> RepairMode is a software platform that facilitates connections between users and independent repair technicians. RepairMode does not perform repairs, and any warranty or guarantee on repair work is provided solely by the individual technician, not by RepairMode.</p>
            </div>
          </div>
        </div>

        {/* How to Use Section */}
        <div className="how-to-section">
          <div className="how-to-content">
            <h2 className="how-to-title">How to Use SearchWorld Marketplace</h2>
            <p className="how-to-subtitle">Search Facebook Marketplace listings from around the world in 3 easy steps</p>
            
            <div className="how-to-steps">
              <div className="how-to-step">
                <span className="step-number">1</span>
                <h3>Log into Facebook</h3>
                <p>Make sure you're logged into Facebook in your browser. The site works best on Google Chrome.</p>
              </div>
              
              <div className="how-to-step">
                <span className="step-number">2</span>
                <h3>Enter Your Search</h3>
                <p>Type what you're looking for and select a country or search worldwide. Click a category to browse.</p>
              </div>
              
              <div className="how-to-step">
                <span className="step-number">3</span>
                <h3>Set Distance to 500 Miles</h3>
                <p>On the Marketplace results page, adjust the distance slider to 500 miles for maximum results.</p>
              </div>
            </div>

            <div className="how-to-tips">
              <h3>Tips for Best Results</h3>
              <ul>
                <li>Return to SearchWorld Marketplace for each new search</li>
                <li>Use PayPal with buyer protection for shipped items</li>
                <li>Items can be shipped via USPS, FedEx, or other carriers</li>
              </ul>
            </div>

            <div className="how-to-link">
              <Link to="/faq">View Full FAQ →</Link>
            </div>
          </div>
        </div>

        <div className="about-section">
          <div className="about-content">
            <div className="about-main">
              <div className="about-cta">
                <p>Ready to start searching worldwide?</p>
                <Link to="/" className="about-button">Start Searching</Link>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default About
